import {
  DataTypeConfig,
  ObjectMapperConfig,
  PrunedStateConfig,
  QueryDefinition,
  SidebarGroupConfig,
  StateConfig,
  ViewConfig,
} from '@helo/cms'
import { StateCreator } from 'zustand'

export type CmsState = {
  /** Used by the application UI. */
  sidebarConfigs: SidebarGroupConfig[]
  /** Used by the application UI. */
  queryDefinitions: QueryDefinition[]
  /** Used by the application UI. */
  baseDataTypeConfigs: DataTypeConfig[]
  /** Used by the application UI. */
  baseStateConfigs: PrunedStateConfig[]
  /** Used by the application UI. */
  viewConfigs: ViewConfig[]
  /** Raw values from the API before `setupDataTypeConfigs` runs. */
  dataTypeConfigs: DataTypeConfig[]
  /** Raw values from the API before `setupDataTypeConfigs` runs. */
  stateConfigs: StateConfig[]
  /** Raw values from the API before `setupDataTypeConfigs` runs. */
  mapperConfigs: ObjectMapperConfig[]
  /** Hash of the supergraph schema the current CMS configs were loaded from. */
  schemaHash: string | null
}

export type CmsSlice = {
  cms: CmsState
}

/** Zustand slice: CMS configuration and derived base configs. */
export const cmsSlice: StateCreator<CmsSlice, [], [], CmsSlice> = (
  set,
  get,
) => ({
  cms: {
    sidebarConfigs: [],
    queryDefinitions: [],
    baseDataTypeConfigs: [],
    dataTypeConfigs: [],
    baseStateConfigs: [],
    viewConfigs: [],
    stateConfigs: [],
    mapperConfigs: [],
    schemaHash: null,
  },
})
